<template>
    <div class="modal-roomlist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">房间修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="楼宇" required prop="buildingCode">
                                    <el-select v-model="editForm.buildingCode" placeholder="点击选择楼宇"  @change="buildingChange" style="width:100%">
                                        <el-option
                                                v-for="item in buildingCodeValue"
                                                :key="item.buildingCode"
                                                :label="item.name"
                                                :value="item.buildingCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="楼层" required prop="floor">
                                    <el-select v-model="editForm.floor" placeholder="请选择楼层" style="width:100%">
                                        <el-option
                                                v-for="item in floorValue"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="房间号" required prop="number">
                                    <el-input v-model.number="editForm.number"  placeholder="请输入房间号" ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="房间类型" required prop="roomTypeCode">
                                    <el-select v-model="editForm.roomTypeCode" placeholder="请选择房间类型" style="width:100%">
                                        <el-option
                                                v-for="item in roomTypeList"
                                                :key="item.roomTypeCode"
                                                :label="item.name"
                                                :value="item.roomTypeCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="房间状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="选择房间状态" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        props: ["buildingCodeValue",'roomTypeList'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    roomCode:'',
                    floor:'',
                    buildingCode:'',
                    number:null,
                    roomTypeCode:'',
                    status:''
                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                floorValue:[],
                rules:{
                    floor:[
                        { required: true, message: '请输入楼层', trigger: 'blur' },
                    ],
                    number:[
                        { required: true, message: '请输入房间号', trigger: 'blur' },
                    ],
                    buildingCode:[
                        { required: true, message: '请选择楼宇', trigger: 'blur' },
                    ],
                    roomTypeCode:[
                        { required: true, message: '请选择房间类型', trigger: 'blur' },
                    ],
                }

            }
        },

        methods: {

            init(row){
                console.log(row);
                this.editForm.number = row.number;
                this.editForm.floor = row.floor;
                this.editForm.buildingCode = row.buildingCode;
                this.editForm.roomCode = row.roomCode;
                this.editForm.roomTypeCode = row.roomTypeCode;
                this.editForm.status = row.status;
                for(var i in this.buildingCodeValue){
                    if(this.buildingCodeValue[i].buildingCode==this.editForm.buildingCode){
                        var floor=this.buildingCodeValue[i].floor
                        this.getfloorValue(floor)
                    }
                }
            },

           buildingChange:function(selVal){
                var floor='';
                for(var i in this.buildingCodeValue){
                    if(this.buildingCodeValue[i].buildingCode==selVal){
                        floor=this.buildingCodeValue[i].floor
                    }
                }
                this.editForm.floor='';
                this.getfloorValue(floor)
            },
            getfloorValue:function(floor){
                var list=[];
                for(var j=0;j<floor;j++){
                    var listValue={}
                    listValue.label=j+1;
                    listValue.value=j+1;
                    list.push(listValue)
                }
                this.floorValue=list;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Room/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-roomlist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        
        .modal {
            
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
